/**
 * 「내 메일함」이 바뀌었다고 서로에게 알리는 자리 (2026-09-06 사용자 육안 지적).
 *
 * ★★ **왜 필요한가.** 같은 화면 안에 메일함을 고치는 자리가 **둘**이다 —
 *    왼쪽 레일의 나무(`MailFolderTree`)와 오른쪽 환경설정 「메일함」 탭
 *    (`MailSettingsFolders`). 둘은 각자 제 상태로 목록을 들고 있어서, 한쪽에서 만들어도
 *    **다른 쪽은 새로고침을 해야 보였다.** 환경설정에서 메일함을 만들었는데 바로 옆
 *    레일에 안 생기는 것이 그것이다.
 * ★ 상태를 한 곳으로 올리지 않고 **알림만** 오간다 — 저장 구조를 바꾸면 레일·설정·이동
 *   창까지 한꺼번에 건드려야 해서, 지금 도는 것을 깨뜨릴 위험이 알림보다 크다.
 * ★ **알린 쪽은 자기 자신을 안 받는다**(`self`). 부르는 쪽은 이미 제 목록을 다시 읽고
 *   있어서, 안 걸러 내면 같은 요청이 두 번 나간다.
 */

type Listener = () => void;

const listeners = new Set<Listener>();

/** 메일함을 만들었다·옮겼다·지웠다·비웠다 — 다른 화면들에게 알린다. */
export function notifyMailFoldersChanged(self?: Listener): void {
  // 사본을 돈다 — 듣는 쪽이 그 자리에서 구독을 끊어도 안전하게.
  for (const fn of [...listeners]) if (fn !== self) fn();
}

/** 알림을 듣는다. 돌려주는 함수를 부르면 끊긴다(effect 의 정리 함수로 쓴다). */
export function subscribeMailFolders(fn: Listener): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

/** 검사끼리 구독이 새지 않게. */
export function _resetMailFolderBusForTests(): void {
  listeners.clear();
}
